import $ from "jquery";
import { toggleScrollLock } from "./scrollLock";

/**
 * Toggle
 */
export default class Toggle {

	constructor() {

		this.setupToggles();
		this.watchForResize();
		this.untoggleOnEscape();

	}

	setupToggles() {

		$( "body" ).on( "click", "*[data-toggle-element]", function() {

			const $trigger = $( this );
			const target   = $trigger.data( "toggle-element" );
			let $target    = $( target );

			if ( target === "next" ) {
				$target = $trigger.next();
			}

			/**
			 * If we have specified a specific classname
			 * to toggle on the element, we want to get it.
			 */
			const classToToggle = $trigger.data( "toggle-class" ) ? $trigger.data( "toggle-class" ) : "is-active";

			/**
			 * If we have specified a specific classname
			 * to toggle on the body, we want to get it.
			 */
			const bodyClassToToggle = $trigger.data( "toggle-body-class" ) ? $trigger.data( "toggle-body-class" ) : "";

			/**
			 * If we set the toggle-lock-screen data attr, then we should
			 * be locking the screen from scrolling when toggle is active.
			 */
			const shouldLockScreen = $trigger.data( "toggle-screen-lock" ) !== undefined ? true : false;

			/**
			 * Get the toggle type.
			 */
			const toggleType = $trigger.data( "toggle-type" ) ? $trigger.data( "toggle-type" ) : "";

			/**
			 * Get the toggle duration.
			 */
			const toggleDuration = $trigger.data( "toggle-duration" ) ? parseInt( $trigger.data( "toggle-duration" ) ) : 250;

			/**
			 * Do the toggle.
			 */
			if ( "slidetoggle" === toggleType ) {
				$target.slideToggle( toggleDuration );
			} else {
				$target.toggleClass( classToToggle );
			}

			/**
			 * If we are toggling the next element, give
			 * only the clicked toggle the active class.
			 *
			 * Otherwise, toggle everything with the target
			 * class.
			 */
			if ( target === "next" ) {
				$trigger.toggleClass( "is-active" );
			} else {
				$( "*[data-toggle-element=\"" + target + "\"]" ).toggleClass( "is-active" );
			}

			/**
			 * If we are toggling a body class,
			 * do this now.
			 */
			if ( bodyClassToToggle ) {
				$( "body" ).toggleClass( bodyClassToToggle );
			}

			/**
			 * Lock/unlock screen.
			 */
			if ( shouldLockScreen ) {
				toggleScrollLock();
			}

			/**
			 * We can choose to set focus when toggling.
			 */
			const setFocusElement = $trigger.data( "set-focus" ) ? $trigger.data( "set-focus" ) : null;

			if ( setFocusElement ) {
				const $focusEl = $( setFocusElement );

				if ( $focusEl.length > 0 ) {
					if ( $trigger.is( "is-active" ) ) {
						$focusEl.focus();
					} else {
						$focusEl.blur();
					}
				}
			}

			/**
			 * Trigger a toggled event.
			 */
			$target.triggerHandler( "toggled" );

			return false;

		} );
	}

	watchForResize() {

		/**
		 * Only watch if an element on the page
		 * allows for resize actions.
		 */
		if ( $( "*[data-untoggle-above], *[data-untoggle-below], *[data-toggle-above], *[data-toggle-below]" ).length ) {
			$( window ).on( "resize", function() {

				const windowWidth = $( window ).width();
				const toggles     = document.querySelectorAll( ".toggle" );

				toggles.forEach( ( toggle ) => {

					const $toggle       = $( toggle );
					const untoggleAbove = toggle.dataset.untoggleAbove ? toggle.dataset.untoggleAbove : null;
					const untoggleBelow = toggle.dataset.untoggleBelow ? toggle.dataset.untoggleBelow : null;
					const toggleAbove   = toggle.dataset.toggleAbove ? toggle.dataset.toggleAbove : null;
					const toggleBelow   = toggle.dataset.toggleBelow ? toggle.dataset.toggleBelow : null;

					/**
					 * If none of the settings are set, bail.
					 */
					if ( ! untoggleAbove && ! untoggleBelow && ! toggleAbove && ! toggleBelow ) {
						return;
					}

					/**
					 * If the current width matches the setting
					 * width, then do the toggle.
					 */
					if (
						( ( ( untoggleAbove && windowWidth > untoggleAbove ) ||
						    ( untoggleBelow && windowWidth < untoggleBelow ) ) &&
						  $toggle.hasClass( "is-active" ) )
						||
						( ( ( toggleAbove && windowWidth > toggleAbove ) ||
						    ( toggleBelow && windowWidth < toggleBelow ) ) &&
						  ! $toggle.hasClass( "is-active" ) )
					) {
						$toggle.trigger( "click" );
					}

				} );
			} );
		}

	}

	untoggleOnEscape() {

		$( document ).keyup( function( e ) {
			if ( e.key === "Escape" ) {

				$( "*[data-untoggle-on-escape].is-active" ).each( function() {
					if ( $( this ).hasClass( "is-active" ) ) {
						$( this ).trigger( "click" );
					}
				} );
			}
		} );

	}

}
